import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/image.png';
import './Header.css';

function Header() {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo-container">
        <img src={logo} alt="IntellectIT Logo" className="logo-img bounce-logo" />
        <span className="company-name"> Hiten Technologies</span> 
      </div>

      <div className="nav-right">
        <div className="nav-links">
          <Link to="/">Home</Link>

          {/* Services Dropdown */}
          <div 
            className="dropdown"
            onMouseEnter={() => setDropdownOpen(true)}
            onMouseLeave={() => setDropdownOpen(false)}
          >
            <span className="dropdown-toggle" onClick={toggleDropdown}>Services </span>
            {dropdownOpen && (
              <div className="dropdown-menu">
              <ul>
            <li><a href="/services#software">Custom Software Development</a></li>
            <li><a href="/services#web-mobile">Web & Mobile App </a></li>
            <li><a href="/services#erp-sap">ERP & SAP Services</a></li>
            <li><a href="/services#cloud-devops"> Cloud & DevOps Solutions</a></li>
             <li><a href="/services#ai-analytics">AI & Data Analytics</a></li>
            <li><a href="/services#marketing-seo">Digital Marketing & SEO</a></li>
            <li><a href="/services#consulting">IT Consulting & Digital Transformation</a></li>
            <li><a href="/services#ui-ux">UI/UX & Product Design</a></li>
          </ul>
              </div>
            )}
          </div>

          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>

        {/* <Link to="/contact">
          <button className="get-started-btn">Get Started</button>
        </Link> */}
      </div>
    </nav>
  );
}

export default Header;
